// extracted by mini-css-extract-plugin
export var borderLine = "styles-module--border-line--X+twF";
export var bottom = "styles-module--bottom--TnwDK";
export var content = "styles-module--content--qMXHz";
export var date = "styles-module--date--8dqLZ";
export var dismissAll = "styles-module--dismissAll--8ZQUS";
export var item = "styles-module--item--GQWJG";
export var notContent = "styles-module--notContent--9An2p";
export var read = "styles-module--read--P9z8o";
export var title = "styles-module--title--LtOSw";